import React, { useEffect, useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import classNames from 'classnames';
import { Link } from 'react-router-dom';
import { Card, Dropdown, ListGroup } from 'react-bootstrap';
import { isIterableArray } from 'helpers/utils';
import FalconCardHeader from 'components/common/FalconCardHeader';
import Notification from 'components/notification/Notification';
import NotificationService from 'components/app/notifications/NotificationService';

const NotificationDropdown = () => {
  // State

  const [isOpen, setIsOpen] = useState(false);
  const [isAllRead, setIsAllRead] = useState(false);
  const [newNotifications, setNewNotifications] = useState();
  const [earlierNotifications, setEarlierNotifications] = useState();
  const [showNotifications, setShowNotifications] = useState(false);

  const convertTime = time => {
    const date = new Date(time);
    return date.toLocaleDateString();
  };

  // Handler
  const handleToggle = () => {
    setIsOpen(!isOpen);
  };

  useEffect(() => {
    window.addEventListener('scroll', () => {
      window.innerWidth < 1200 && setIsOpen(false);
    });
    NotificationService.retrieveAllNotificationByUser()
      .then(notifications => {
        const lastDay = new Date();
        lastDay.setDate(lastDay.getDate() - 1);

        setShowNotifications(notifications.length > 0);
        const lastNotifications = notifications
          .filter(d => {

            return new Date(d.time).getTime() >= lastDay.getTime();
          })
          .map(n => {
            return { ...n, time: convertTime(n.time) };
          });

        const olderNotifications = notifications
          .filter(d => {
            return new Date(d.time).getTime() < lastDay.getTime();
          })
          .map(n => {
            return { ...n, time: convertTime(n.time) };
          });

        setNewNotifications(lastNotifications);
        setEarlierNotifications(olderNotifications);
      })
      .catch(error => console.log(error));
  }, []);

  const markAsRead = e => {
    e.preventDefault();

    const updatedNewNotifications = newNotifications.map(notification =>
      Object.prototype.hasOwnProperty.call(notification, 'unread')
        ? { ...notification, unread: false }
        : notification
    );
    const updatedEarlierNotifications = earlierNotifications.map(notification =>
      Object.prototype.hasOwnProperty.call(notification, 'unread')
        ? { ...notification, unread: false }
        : notification
    );

    setIsAllRead(true);
    setNewNotifications(updatedNewNotifications);
    setEarlierNotifications(updatedEarlierNotifications);
  };

  return (
    <>
      <Dropdown navbar={true} as="li" show={isOpen} onToggle={handleToggle}>
        <Dropdown.Toggle
          bsPrefix="toggle"
          as={Link}
          to="#!"
          className={classNames('px-0 nav-link', {
            'notification-indicator notification-indicator-primary': !isAllRead
          })}
        >
          <FontAwesomeIcon icon="bell" transform="shrink-6" className="fs-4"/>
        </Dropdown.Toggle>

        <Dropdown.Menu className="dropdown-menu-card dropdown-menu-end dropdown-caret dropdown-caret-bg">
          <Card
            className="dropdown-menu-notification dropdown-menu-end shadow-none"
            style={{ maxWidth: '20rem' }}
          >
            {showNotifications && (
              <FalconCardHeader
                className="card-header"
                title="Notifications"
                titleTag="h6"
                light={false}
                endEl={
                  <Link
                    className="card-link fw-normal"
                    to="#!"
                    onClick={markAsRead}
                  >
                    Mark all as read
                  </Link>
                }
              />
            )}
            <ListGroup
              variant="flush"
              className="fw-normal fs--1 scrollbar"
              style={{ maxHeight: '19rem' }}
            >
              {showNotifications && newNotifications && newNotifications.length > 0 && (<div className="list-group-title">NEW</div>)}
              {newNotifications &&
                isIterableArray(newNotifications) &&
                newNotifications.map(notification => (
                  <ListGroup.Item key={notification.id} onClick={handleToggle}>
                    <Notification {...notification} flush />
                  </ListGroup.Item>
                ))}
              {showNotifications && earlierNotifications && earlierNotifications.length > 0 && (
                <div className="list-group-title">EARLIER</div>
              )}
              {earlierNotifications &&
                isIterableArray(earlierNotifications) &&
                earlierNotifications.map(notification => (
                  <ListGroup.Item key={notification.id} onClick={handleToggle}>
                    <Notification {...notification} flush />
                  </ListGroup.Item>
                ))}
            </ListGroup>
            <div
              className="card-footer text-center border-top"
              onClick={handleToggle}
            >
              {showNotifications && (
                <Link className="card-link d-block" to="/app/notifications">
                  View all
                </Link>
              )}
              {!showNotifications && (
                <Link className="card-link d-block" to="/app/notifications">
                  You don't have any notification
                </Link>
              )}
            </div>
          </Card>
        </Dropdown.Menu>
      </Dropdown>
    </>
  );
};

export default NotificationDropdown;
